import { FC } from 'react';

export const WlasCopySmallIcon: FC = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <rect x="1" y="4" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M4 4V2.5C4 1.67 4.67 1 5.5 1H10.5C11.33 1 12 1.67 12 2.5V7.5C12 8.33 11.33 9 10.5 9H9"
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </svg>
);
